import { ITerm } from './index';

/**
 * SER_004: 개인정보 제3자 제공 동의
 * 각 통신사가 오버테이크(OT)에 개인정보를 제공하는 것에 대한 동의 (주체: 각 통신사 / 제공받는 자: OT)
 * KT/SKT 반영, LGU+는 매체 협의 후 추가 예정 (OTDK-1828)
 */
const MEDIA_SERVICE_TERM_ITEM: {
  [media: string]: { title: string; termCd: string; path: string } | undefined;
} = {
  kt: {
    title: '개인정보 제3자 제공 동의',
    termCd: 'SER_004',
    path: '/terms/SERVICE_4_KT.html',
  },
  skt: {
    title: '개인정보 제3자 제공 동의',
    termCd: 'SER_004',
    path: '/terms/SERVICE_4_SKT.html',
  },
  // lgu: 매체 협의 후 추가 예정 (단, lgu는 네이티브 약관 화면을 사용하므로 이 화면 자체를 타지 않음)
};

const SERVICE_GROUP_TEXT_MARKER = '서비스 필수 항목 모두 동의';

/**
 * 신용대출/주담대 약관 목록(TERM_CREDIT_LOAN / TERM_MTG_LOAN)에
 * 통신사(media)별 "서비스 필수 항목" 약관을 추가해서 반환한다.
 * media에 해당하는 추가 약관이 없으면 원본을 그대로 반환한다.
 */
export const applyMediaServiceTerms = (
  terms: ITerm[],
  media?: string,
): ITerm[] => {
  const extraItem = media ? MEDIA_SERVICE_TERM_ITEM[media] : undefined;
  if (!extraItem) return terms;

  return terms.map((group) => {
    if (!group.text.includes(SERVICE_GROUP_TEXT_MARKER)) return group;

    const alreadyApplied = group.subTextItem.some(
      (item) => item.termCd === extraItem.termCd,
    );
    if (alreadyApplied) return group;

    return {
      ...group,
      subTextItem: [...group.subTextItem, extraItem],
    };
  });
};
